import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { useCurrentUser, useGetScreenStatus } from '../../hooks';
import { useGleap } from '../../hooks/useGleap';
import { profileRoutes } from '../../routes';
import { SCREEN_STATUS } from '../../types';
import { logOut } from '../../utils/logOut';
import { Dropdown } from '../ui/Dropdown';
import Icon from '../ui/Icon/Icon';
import { Search } from '../ui/Search';
import { theme } from '../ui/themes/default';
import { Text } from '../ui/Typography';
import {
  FiltersSection,
  HeaderWrapper,
  InputWrapper,
  UserAvatar,
  UserDropdownItem,
  UserInfo,
  UserSection,
} from './Header.styles';

export function Header() {
  const currentScreen = useGetScreenStatus();
  const currentUser = useCurrentUser();
  const { clearGleapUserIdentity } = useGleap();

  const handleLogout = useCallback(() => {
    logOut();
    clearGleapUserIdentity();
  }, [clearGleapUserIdentity]);

  const dropdownItems = [
    {
      key: 'userInfo',
      label: (
        <UserDropdownItem>
          <UserAvatar dropdownUser imageUrl={currentUser?.image} />
          <UserInfo>
            <Text variant="bodySemibold" data-cy="username">{`${currentUser?.profile?.firstName || 'N/A'} ${
              currentUser?.profile?.lastName || 'N/A'
            }`}</Text>
            <Text color="secondary" data-cy="user-role">
              {currentUser?.role}
            </Text>
          </UserInfo>
        </UserDropdownItem>
      ),
    },
    ...profileRoutes.map((item) => ({
      key: item.path,
      label: (
        <Link to={item.path}>
          <UserDropdownItem>
            <Icon icon={item.icon} fillColor={theme.secondary} width={20} />
            <Text>{item.label}</Text>
          </UserDropdownItem>
        </Link>
      ),
    })),
    {
      key: 'logout',
      label: (
        <UserDropdownItem onClick={handleLogout}>
          <Text data-cy="logout-button">Log out</Text>
        </UserDropdownItem>
      ),
    },
  ];

  return currentScreen !== SCREEN_STATUS.extraSmall ? (
    <HeaderWrapper>
      <FiltersSection>
        {currentUser?.companyId && (
          <InputWrapper>
            <Search />
          </InputWrapper>
        )}
      </FiltersSection>

      <UserSection>
        <Dropdown dropdownItems={dropdownItems} position="right">
          <UserAvatar data-cy="profile-button" imageUrl={currentUser?.image} />
        </Dropdown>
      </UserSection>
    </HeaderWrapper>
  ) : null;
}
